import { type CohortForAdminListsAttrs } from 'Cohorts';
import { mockCohortsForAdminLists } from 'Cohorts/SpecHelpers';
import { createGetSuccessHandler } from 'FrontRoyalMSW';

export const createCohortGetSuccessHandler = (cohorts: CohortForAdminListsAttrs[]) =>
    createGetSuccessHandler('*/cohorts.json', {
        contents: {
            cohorts,
        },
    }).handler;

export const cohortsHandler = createCohortGetSuccessHandler(mockCohortsForAdminLists);
